import { render } from "./StepActions.vue?vue&type=template&id=5aa26b54&scoped=true"
import script from "./StepActions.vue?vue&type=script&lang=js"
export * from "./StepActions.vue?vue&type=script&lang=js"

import "./StepActions.vue?vue&type=style&index=0&id=5aa26b54&scoped=true&lang=css"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa26b54"]])

export default __exports__